import * as React from 'react';

import { createIcon } from '../Icon';
export const PauseIcon = createIcon(
  <React.Fragment>
    <rect height={16} width={4} x={6} y={4} />
    <rect height={16} width={4} x={14} y={4} />
  </React.Fragment>,
  'PauseIcon'
);
